export const h1 = '32px';
export const h2 = '20px';
export const h3 = '18px';
export const h4 = '16px';
export const h5 = '14px';
export const h6 = '12px';

export const body1 = '16px';
export const body2 = '14px';
export const body3 = '12px';